"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFQCode = exports.getKlineCode = exports.KLineData = void 0;
/**
 * 获取K线数据
 */
var web_1 = __importDefault(require("../../config/web"));
var jsonp_1 = __importDefault(require("../jsonp"));
var tools_1 = require("../tools");
/**
 * K线图jsonp数据
 * @param options
 * @returns
 */
function KLineData(options) {
    return __awaiter(this, void 0, void 0, function () {
        var apiurl, databack, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiurl = web_1.default.getUrl("quote_history_api");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, jsonp_1.default)("".concat(apiurl, "api/qt/stock/kline/get?fields1=f1,f2,f3,f4,f5,f6,f7,f8&fields2=f51,f52,f53,f54,f55,f56,f57,f58,f59,f60,f61,f62,f63,f64,f65&ut=").concat(options.ut, "&secid=").concat(options.quotecode, "&dect=1&klt=").concat(getKlineCode(options.type), "&lmt=").concat(options.count + 10, "&fqt=").concat(getFQCode(options.fq), "&forcect=1&end=20500000&wbp2u=1849325530509956|0|1|0|web"), {
                            param: "cb",
                            //  prefix: 'miniquotechart_jp'
                        })];
                case 2:
                    databack = _a.sent();
                    return [2 /*return*/, dealData(databack)];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, null];
            }
        });
    });
}
exports.KLineData = KLineData;
/** 处理K线数据接口数据 */
function dealData(source_data) {
    try {
        if (source_data.data == null)
            return null;
        var closePriceArr_1 = [];
        var back = {
            pre_price: source_data.data.prePrice,
            pre_kprice: source_data.data.preKPrice,
            dktotal: source_data.data.dktotal,
            decimal: source_data.data.decimal,
            name: source_data.data.name,
            code: source_data.data.code,
            market: source_data.data.market.toString(),
            qtMiscType: source_data.data.qtMiscType,
            klines: source_data.data.klines.map(function (v, index) {
                var tempobj = v.split(",");
                closePriceArr_1.push(parseFloat(tempobj[2]));
                return {
                    index: index,
                    date: tempobj[0],
                    open: parseFloat(tempobj[1]) == 0 ? parseFloat(tempobj[2]) : parseFloat(tempobj[1]),
                    high: parseFloat(tempobj[3]),
                    low: parseFloat(tempobj[4]),
                    close: parseFloat(tempobj[2]),
                    volume: parseInt(tempobj[5]),
                    amount: parseFloat(tempobj[6]),
                    amplitude: parseFloat(tempobj[7]),
                    huanshou: parseFloat(tempobj[10]),
                    phvolume: parseInt(tempobj[11]),
                    phamount: parseFloat(tempobj[12]),
                    zde: parseFloat(tempobj[9]),
                    zdf: (0, tools_1.formatNumToFixed)(parseFloat(tempobj[8]), 0, 2, "", "%"),
                    // 昨结
                    settle: parseFloat(tempobj[14])
                };
            }),
            maArr: [],
            maxLabel: 0,
            minLabel: 0,
        };
        var maArr_1 = [];
        closePriceArr_1.forEach(function (item, index) {
            var ma5 = null, ma10 = null, ma20 = null;
            if (index >= 4) {
                ma5 = (0, tools_1.getArrayItemSum)(closePriceArr_1, index - 4, index) / 5;
            }
            if (index >= 9) {
                ma10 = (0, tools_1.getArrayItemSum)(closePriceArr_1, index - 9, index) / 10;
            }
            if (index >= 19) {
                ma20 = (0, tools_1.getArrayItemSum)(closePriceArr_1, index - 19, index) / 20;
            }
            maArr_1.push({
                ma5: ma5 === null || ma5 === void 0 ? void 0 : ma5.toFixed(4),
                ma10: ma10 === null || ma10 === void 0 ? void 0 : ma10.toFixed(4),
                ma20: ma20 === null || ma20 === void 0 ? void 0 : ma20.toFixed(4),
            });
        });
        back.maArr = maArr_1;
        var showArr = back.klines;
        var showMaArr = back.maArr;
        var maxPrice = (0, tools_1.getTrendMaxOrMin)(showArr, "maxprice", "max");
        var minPrice = (0, tools_1.getTrendMaxOrMin)(showArr, "minprice", "min");
        var maxMA5 = (0, tools_1.getTrendMaxOrMin)(showMaArr, "ma5", "max");
        var minMA5 = (0, tools_1.getTrendMaxOrMin)(showMaArr, "ma5", "min");
        var maxMA10 = (0, tools_1.getTrendMaxOrMin)(showMaArr, "ma10", "max");
        var minMA10 = (0, tools_1.getTrendMaxOrMin)(showMaArr, "ma10", "min");
        var maxLabel = (0, tools_1.getArrayMaxNumber)([maxPrice, minPrice, maxMA5, minMA5, maxMA10, minMA10]);
        var minLabel = (0, tools_1.getArrayMinNumber)([maxPrice, minPrice, maxMA5, minMA5, maxMA10, minMA10]);
        back.maxLabel = maxLabel;
        back.minLabel = minLabel;
        return back;
    }
    catch (error) {
        console.error(error);
    }
    return null;
}
/**
 *  获取K线类型代码
 *  5(5分钟)，15(15分钟)，30(30分钟)，60(60分钟)，101(日)，102(周)，103(月)，104(季)，105(半年)，106(年)
 * @param type
 * @returns
 */
function getKlineCode(type) {
    switch (type) {
        case "k":
            return 101;
        case "wk":
            return 102;
        case "mk":
            return 103;
        case "sk":
            return 104;
        case "hyk":
            return 105;
        case "yk":
            return 106;
        case "5min":
            return 5;
        case "15min":
            return 15;
        case "30min":
            return 30;
        case "60min":
            return 60;
        default:
            return "k";
    }
}
exports.getKlineCode = getKlineCode;
/**
 * 获取复权类型代码
 * @param fq
 * @returns
 */
function getFQCode(fq) {
    switch (fq) {
        case "qfq":
            return 1;
        case "hfq":
            return 2;
        case "bfq":
            return 0;
        default:
            return 1;
    }
}
exports.getFQCode = getFQCode;
